import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {OAuthService} from "angular-oauth2-oidc";
import {environment} from "../../../environments/environment.prod";
import {historicoUtil} from "src/util/historico";

@Injectable()
export class PostingProvider {
  apiBase: string = "/bookkeeping/v1/posting";
  api: string = "/bookkeeping/v1/in_batch";
  apiNew: string = "/bookkeeping/v1/monthly-consolidation";
  apiPayroll: string = "/bookkeeping/v1/payroll";
  apiExport: string = "/bookkeeping/v1/exports/posting";
  apiTaxes: string = "/bookkeeping/v1/tax-simulator";
  apiEsPosting: string = "/bookkeeping/v1/posting/posting-payroll";

  constructor(
    public http: HttpClient,
    public oauthService: OAuthService,
    private historicoUtil: historicoUtil
  ) {
  }

  getAllPostingsNullParticipantIdBankAccountId(companyId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/find-if-participantId-or-bankAccountId-is-null/${companyId}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getAllPosting(before: string, after: string) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/by-company/${localStorage.getItem("idEmpresa")}/${before}/${after}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result);
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getFilteredPostings(before: string, after: string, values: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiBase}/ledger-reports/${localStorage.getItem("idEmpresa")}/${before}/${after}`,
        values,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result);
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getAllPostingExtraFilters(before: string, after: string, filterString: string) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/${localStorage.getItem("idEmpresa")}/${before}/${after}/${filterString}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result);
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getAllPostingNew(before: string, filtros: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiNew}/${localStorage.getItem("idEmpresa")}/${before}`,
        filtros,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getPostingSimplificado(before: string, filtros: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiNew}/simplified-report/${localStorage.getItem("idEmpresa")}/${before}`,
        filtros,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getLastEntries(howMany) {
    const requestString = `${environment.apiLogin}${this.apiBase}/${localStorage.getItem('idEmpresa')}/last/${howMany}`;
    return new Promise((resolve, reject) => {
      this.http.get(requestString, {headers: {Authorization: this.oauthService.authorizationHeader()}})
        .subscribe((result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result)
          resolve(result);
        }, (error) => {
          reject(error);
        });
    });
  }

  getLastEntriesWithDFE(howMany) {
    const requestString = `${environment.apiLogin}${this.apiBase}/${localStorage.getItem('idEmpresa')}/last-with-dfe/${howMany}`;
    return new Promise((resolve, reject) => {
      this.http.get(
        requestString,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result);
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getBalance(date: string) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/balance/${localStorage.getItem("idEmpresa")}/${date}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getDocAndPaymentIDByDoc(docId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/payment/${docId}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getAllByDoc(docId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/${localStorage.getItem("idEmpresa")}/${docId}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          this.historicoUtil.checkHistoricOrObject(result);
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postPosting(Posting: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiBase}/in_batch`,
        Posting,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postPostingBatch(Posting: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.api}`,
        Posting,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  newPostingInBatch(Posting: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}/bookkeeping/v1/posting/save-docs-postings/${localStorage.getItem("idEmpresa")}`,
        Posting,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getDocIdsByDfeIds(dfeIds: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiBase}/doc-ids-by-dfe-ids/${localStorage.getItem("idEmpresa")}`,
        dfeIds,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  putPosting(Posting: any) {
    return new Promise((resolve, reject) => {
      this.http.put(
        `${environment.apiLogin}${this.apiBase}`,
        Posting,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  delPosting(id: number) {
    return new Promise((resolve, reject) => {
      this.http.delete(
        `${environment.apiLogin}${this.apiBase}/${localStorage.getItem("idEmpresa")}/${id}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postImportedFile(document: File, source: string) {
    const formData = new FormData();
    formData.append("file", document);
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiPayroll}/dominio/import-data/${localStorage.getItem("idEmpresa")}/${source}`,
        formData,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postImportedFileToPosting(file: File, type: string) {
    const formData = new FormData();
    formData.append("file", file);
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}/main-records/v1/receipt/upload-file/${localStorage.getItem("idEmpresa")}/${type}`,
        formData,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          if (error.status == 422) {
            reject(error.error);
          } else {
            reject(error);
          }
        }
      );
    });
  }

  importPayroll(lancamentos: any, importModel: string) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiPayroll}/in-batch/${localStorage.getItem("idEmpresa")}/${importModel}`,
        lancamentos,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  exportPostings(filters: any, startDate: string, endDate: string) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiExport}/${localStorage.getItem("idEmpresa")}/${startDate}/${endDate}`,
        filters,
        {
          responseType: "text",
          headers: {Authorization: this.oauthService.authorizationHeader()}
        }
      ).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  postTaxSimulation(simulation: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiTaxes}/${localStorage.getItem("idEmpresa")}`,
        simulation,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  saveTaxSimulation(simulation: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiTaxes}/${localStorage.getItem("idEmpresa")}/save`,
        simulation,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getPaged(page: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiTaxes}/${localStorage.getItem("idEmpresa")}/paged/${page}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  deleteSimulation(id: number) {
    return new Promise((resolve, reject) => {
      this.http.delete(
        `${environment.apiLogin}${this.apiTaxes}/${localStorage.getItem("idEmpresa")}/${id}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getAllByIds(ids: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiBase}/get-by-ids/${localStorage.getItem("idEmpresa")}`,
        ids,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  createPostingsFromFinancing(id: number, arr: any[]) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiBase}/in_batch/${localStorage.getItem("idEmpresa")}/from-financing/${id}`,
        arr,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  createEsPosting(items: any) {
    return new Promise((resolve, reject) => {
      this.http.post(
        `${environment.apiLogin}${this.apiEsPosting}/${localStorage.getItem("idEmpresa")}`,
        items,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  getDocIdByPostingId(postingId: number) {
    return new Promise((resolve, reject) => {
      this.http.get(
        `${environment.apiLogin}${this.apiBase}/doc-id-by-posting-id/${localStorage.getItem("idEmpresa")}/${postingId}`,
        {headers: {Authorization: this.oauthService.authorizationHeader()}}
      ).subscribe(
        (result: any[]) => {
          resolve(result);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}
